(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 55006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91001);
/* harmony import */ var _src_components_ResponsiveAppBar_ResponsiveAppBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52240);
/* harmony import */ var _src_pages_Show_Show__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79081);
/* harmony import */ var _src_components_Auth_WithAuthHandler_WithAuthHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8885);
/* harmony import */ var _src_components_Auth_WithAdminAuthHandler_WithAdminAuthHandler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99418);
/* harmony import */ var _src_contexts_CustomThemeProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75044);
/* harmony import */ var src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82030);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);














var HomePage = function HomePage(_ref) {
  var dashboards = _ref.dashboards,
      companyHealthScore = _ref.companyHealthScore;
  var seoTitle = "Home | That's The Ticket";

  var _useAuthContext = (0,src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_9__/* .useAuthContext */ .E)(),
      user = _useAuthContext.user;

  var _useColorModeContext = (0,_src_contexts_CustomThemeProvider__WEBPACK_IMPORTED_MODULE_8__/* .useColorModeContext */ .XE)(),
      setColorMode = _useColorModeContext.setColorMode;

  setColorMode("light");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("title", {
        children: "".concat(seoTitle)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:title",
        content: seoTitle
      }, "ogTitle"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:title",
        content: seoTitle
      }, "twitterTitle")]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_src_components_ResponsiveAppBar_ResponsiveAppBar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      user: user
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_src_pages_Show_Show__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      dashboards: dashboards,
      companyHealthScore: companyHealthScore
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_src_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_src_components_Auth_WithAuthHandler_WithAuthHandler__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_src_components_Auth_WithAdminAuthHandler_WithAdminAuthHandler__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,next_router__WEBPACK_IMPORTED_MODULE_1__.withRouter)(HomePage))));

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(55006);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4891,3840,8392,5184,961,2872,6111,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);